module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic17.f671fac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic17.png
// module id = 516
// module chunks = 1